module.exports = __webpack_public_path__ + "static/media/3.28f66f52.jpg";